import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
} from "@material-ui/core";
import { useSnackbar } from 'notistack5';

export default function DemoRestrictionDialog({ open, onClose }) {
  const [form, setForm] = useState({ name: "", contact: "" });
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
  console.log("Form submitted:", form);
  enqueueSnackbar("Form submitted successfully!", { variant: "success" });

  setForm({ name: "", contact: "" });

  onClose();
};

  return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            zIndex: 999999999, 
          },
          "& .MuiBackdrop-root": {
            zIndex: 999999999, 
          },
        }}
      >
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", pb: 1 }}>
        Want to try the full Sparkle Time Keeping Experience?
      </DialogTitle>

      {/* Body */}
      <DialogContent sx={{ textAlign: "center" }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Some features are disabled in demo mode. To try the full Sparkle Time
          Keeping experience — contact our Business Development Team today.
        </Typography>

        {/* Contact info */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            📞 09950426755
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "primary.main", wordBreak: "break-word" }}
          >
            ✉️ danica.damlig.starjobs@gmail.com
          </Typography>
        </Box>

        {/* Small form */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            name="name"
            label="Name"
            variant="outlined"
            size="small"
            fullWidth
            value={form.name}
            onChange={(e) => {
              const value = e.target.value;
              // ✅ Allow only letters, spaces, and limit length to 50
              if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 50) {
                setForm((prev) => ({ ...prev, name: value }));
              }
            }}
            inputProps={{
              maxLength: 50, // safety net
            }}
          />
          <TextField
            name="contact"
            label="Contact Number"
            variant="outlined"
            size="small"
            fullWidth
            value={form.contact}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 11) {
                setForm((prev) => ({ ...prev, contact: value }));
              }
            }}
            inputProps={{
              inputMode: "numeric", 
              pattern: "[0-9]*",   
              maxLength: 11         
            }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
          >
            Send
          </Button>
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button variant="contained" color="secondary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
